import styled from "styled-components";

export const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 900;
  margin: 0;
  color: black;
  text-align: center;
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const GradientText = styled.span`
  background: linear-gradient(to right, #3b82f6, #ec4899, #f97316);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
`

export const Description = styled.div`
  color: black;
  font-size: 1rem;
  margin: 8px auto;
  text-align: ${props => props.textCenter ? "center" : "none"};
  @media (max-width: 768px) {
    text-align: center;
  }
`;

export const Container = styled.div`
  padding-top: 24px;
  padding-bottom: 24px;
`;
